import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { MasterOperatorModule } from '@cloud-twin/master-operator/master-operator.module';
import { ConfigurableFiltersModule } from '@common-modules/configurable-filters/configurable-filters.module';
import { ConfigurableFormModule } from '@common-modules/configurable-form/configurable-form.module';
import { DynamicLayoutModule } from '@common-modules/dynamic-layout/dynamic-layout.module';
import { GenericStoreService } from '@common-modules/dynamic-layout/state/generic/generic-store.service';
import { ReduxStateModule } from '@common-modules/redux/redux-state.module';
import { CommonSharedComponentModule } from '@common-modules/shared-component/common-shared-component.module';
import { CommonSharedModule } from '@common-modules/shared/common-shared.module';
import { MaterialSharedModule } from '@common-modules/shared/material-shared.module';
import { WidgetRegistryService } from '@common-modules/widget-registry/widget-registry';
import { WLMGridModule } from '@common-modules/wlm-grid/wlm-grid.module';
import { TranslateModule } from '@ngx-translate/core';
import { MeasurePointConfigurationComponent } from './measure-point-configuration/measure-point-configuration.component';
import { MeasurementFiltersComponent } from './measurement-filters/measurement-filters.component';
import { PointConfigurationsService } from './services/point-configurations.service';
import { TelemetryPointsService } from './services/telemetry-points.service';
import { TelemetryPageComponent } from './telemetry-page/telemetry-page.component';
import { TelemetryRoutingModule } from './telemetry-routing.module';

@NgModule({
  declarations: [TelemetryPageComponent, MeasurePointConfigurationComponent, MeasurementFiltersComponent],
  imports: [
    ReduxStateModule,
    CommonModule,
    CommonSharedModule,
    CommonSharedComponentModule,
    MaterialSharedModule,
    TranslateModule,
    DynamicLayoutModule,
    MasterOperatorModule,
    ReduxStateModule.forFeature({
      storeServices: [GenericStoreService],
    }),
    WLMGridModule,
    TelemetryRoutingModule,
    ConfigurableFiltersModule,
    ConfigurableFormModule
  ],
  providers: [TelemetryPointsService,
    { provide: 'TelemetryPointsService', useExisting: TelemetryPointsService },
    PointConfigurationsService,
    { provide: 'PointConfigurationsService', useExisting: PointConfigurationsService }
  ],
  exports: [
    TelemetryPageComponent,
  ],
})
export class TelemetryModule {
  static injector: Injector;
  constructor(injector: Injector, private _widgetRegistry: WidgetRegistryService) {
    TelemetryModule.injector = injector;

    this._widgetRegistry.register([
      {
        name: 'MeasurePointConfigurationComponent',
        widgetClass: MeasurePointConfigurationComponent,
      }
    ]);
  }
}
